import React from 'react';
import { Grid, List, ListItemText, ListItemButton, ListItemIcon, Button, Fab, Tooltip } from '@mui/material';
import { KeyboardArrowLeftRounded, FiberManualRecord, MapRounded } from '@mui/icons-material';
import { isArray, isEmpty } from 'lodash';

export default function NavigationDrawer({ sections, currentSectionIndex, onChange, hidden, onHiddenChange }) {
  if (!isArray(sections) || isEmpty(sections)) return null;

  return (
    <Grid container alignContent={'baseline'} direction={'column'} wrap="nowrap" sx={{ height: '100%' }}>
      {hidden ? (
        <Grid container sx={{ p: 2 }}>
          <Tooltip title="Show navigation">
            <Fab color="primary" onClick={() => onHiddenChange(false)}>
              <MapRounded />
            </Fab>
          </Tooltip>
        </Grid>
      ) : (
        <>
          <Grid container item sx={{ mt: 1 }}>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<KeyboardArrowLeftRounded />}
              onClick={() => onHiddenChange(true)}
            >
              hide navigation
            </Button>
          </Grid>
          <Grid container item sx={{ flex: 1, overflow: 'auto' }}>
            <List sx={{ width: '100%' }}>
              {sections.map((section, i) => (
                <ListItemButton
                  sx={{
                    borderRadius: 50,
                    border: i === currentSectionIndex ? (theme) => `1px solid ${theme.palette.primary.main}` : '',
                    my: '2px',
                  }}
                  onClick={() => onChange(i)}
                  key={section.id}
                  selected={i === currentSectionIndex}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <FiberManualRecord />
                  </ListItemIcon>
                  <ListItemText primary={section.title || `Section #${i + 1}`} />
                </ListItemButton>
              ))}
            </List>
          </Grid>
        </>
      )}
    </Grid>
  );
}
